
document.addEventListener('DOMContentLoaded', function() {
	initSwiper();
	initMegamenu();
	socialFeed();
	initAccordeon()
	//initLax();
	AOS.init({
		offset: window.innerHeight / 5,
		duration: 600,
		easing: 'ease-out',
		once: true,
	});
});


const initAccordeon = () => {
	// if click on #accordeon details tag item, change the swiper (#swiper-wrapper-04bf071f055c5895) item of #galerie-accordeon with same index
	const accordeon = document.querySelectorAll('#accordeon details');
	if(accordeon) {
		accordeon.forEach(detail => {
			detail.addEventListener('click', (el) => {
				const swiperItems = document.querySelectorAll('#galerie-accordeon .swiper-pagination-bullet');
				const index = el.currentTarget.querySelector("summary").dataset.accordionIndex - 1;
				swiperItems[index].click();
				
			});
		});
	}
}
const socialFeed = () => {
	if(document.querySelector(".juicer")) {
		let container = document.querySelector(".juicer");
		let feed = container.dataset.juicer;
		let posts = container.dataset.limit;
		new InitInstagram({
			feed,
			posts,
			container,
		});
	}
}

const initMegamenu = () => {
	let megamenu = document.querySelector('#mon_mega_menu');
	if(megamenu) {
		let links = megamenu.querySelectorAll('.mega-menu-item');
		let image_placeholder = megamenu.querySelector('#mega-menu-image-replace img');
		links.forEach(link => {
			link.addEventListener('mouseenter', (el) => {
				image_placeholder.src = el.target.dataset.image;
			});
		});
	}
}
const initLax = () => {
	lax.init();
	lax.addDriver('scrollY', function () {
		return window.scrollY;
	});
	lax.addElements('.realisations-grid .realisation.paire a', {
		scrollY: {
			translateY: [
				["elInY", "elOutY"],
				[-200, 200],
				
			]
		}
	})
}
const initSwiper = () => {
	const swiperElements = document.querySelectorAll('.other_competences.swiper, .exemples_realisations.swiper');
	swiperElements.forEach(swiperElement => {
		const swiperInstance = new Swiper(swiperElement, {
			slidesPerView: "auto",
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	});

	const galerieElements = document.querySelectorAll('.galerie.swiper');
	galerieElements.forEach(swiperElement => {
		const galerieInstance = new Swiper(swiperElement, {
			slidesPerView: "auto",
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});
	});

	// Témoignages
	const temoinElements = document.querySelectorAll('.swiper-temoignages');
	temoinElements.forEach(swiperElement => {
		const temoinInstance = new Swiper(swiperElement, {
			slidesPerView: 1,
			effect: 'fade',
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
		});
	});

	// Blog
	const blogElements = document.querySelectorAll('.blog-swiper');
	blogElements.forEach(swiperElement => {
		const blogInstance = new Swiper(swiperElement, {
			slidesPerView: "auto",
		});
	});
}
class InitInstagram {
	constructor(params) {
		this.feed = params.feed;
		this.posts = params.posts;
		this.flux = params.container;
		this.init();
	}
	//Show html string in plain text (remove html)
	
	init() {
		if (this.flux) {
			fetch("https://www.juicer.io/api/feeds/" + this.feed)
				.then((data) => data.json())
				.then((res) => {
					let posts = res.posts.items.slice(0, this.posts);
                              let element = `<div class="swiper-juicer swiper"><div class="swiper-wrapper">`;
					posts.map((item) => {
						console.log(item);
                                    element += `<div class="swiper-slide">
							<a href=${item.full_url} target="_blank"
								title="Voir sur Facebook"
								class="juicer-post">
								<img loading="lazy" src=${item.image} alt="Suivez Devers sur Instagram"   />
								<div class="juicer-post-content">
									<p>${stripHtml(item.message)}</p>
								</div>
							</a>
						</div>`;
					});
                              element += `</div>
					<div class="swiper-button-prev"></div>
					<div class="swiper-button-next"></div>
					</div>`;
                              this.flux.innerHTML += element;
                              setTimeout(() => {
                                    const swiper = new Swiper('.swiper-juicer', {
                                          direction: 'horizontal',
                                          slidesPerView: "auto",
                                          loop: false,
							navigation: {
								nextEl: '.swiper-button-next',
								prevEl: '.swiper-button-prev',
							},
                                    });                                   
                              }, 500)
                              
				});
		}
	}
}

const stripHtml = (html) => {
	var tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	return tmp.textContent.slice(0, 180) + "..." || tmp.innerText.slice(0, 180) + "..." || "";
}
